import SvgMapper from "../features/common/SvgMapper"

const InterviewReviewHeader =() =>{
    return(
          <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Interview Reviews</h1>
          <p className="text-gray-600 mt-1">
            Review and evaluate completed student interviews
          </p>
        </div>
        <div className="flex items-center space-x-3">
          <div className="flex items-center space-x-2">
            {SvgMapper.filter("w-4 h-4 text-gray-500")}
            <select className="px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-yellow-400 focus:border-transparent">
              <option value="all">All Interviews</option>
              <option value="completed">Completed</option>
              <option value="flagged">Flagged</option>
            </select>
          </div>
        </div>
      </div>
    )
}

export default InterviewReviewHeader;